import EvalImportEvalScore from './src/main';

/* istanbul ignore next */
EvalImportEvalScore.install = function(Vue) {
  Vue.component(EvalImportEvalScore.name, EvalImportEvalScore);
};

export default EvalImportEvalScore;
